import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { CursorPaginated } from "@types";
import { IFilteredColumn } from "@funcional/react-table-ui";
import { useParams } from "react-router-dom";
import { IProgramParams, IRefundTransaction } from "../contracts";
import { filterOptions, formatTransactions, handleFilter, transformStringToDate } from "../helpers";

export enum ProcessStatusEnum {
  CALCULATED = "CALCULATED",
  RECALCULATED = "RECALCULATED",
  NO_RULE = "NO_RULE",
  NO_FORMULA = "NO_FORMULA",
}
export interface ITransactionFilter {
  programId: number;
  headquarterName?: string;
  establishmentCodes: string;
  productName: string;
  processStatus: ProcessStatusEnum;
  productIds: number,
  productCodes: string,
  establishmentIds: number,
  salesDate: string,
  salesIds: number,
  saleStatus: string,
  before?: string;
  after?: string;
  first?: number;
  last?: number;
}
export interface UseTransactionsOptions {
  filter?: ITransactionFilter;
  gridFilters?: IFilteredColumn[];
}

export function useTransactions(options: UseTransactionsOptions | undefined = {}) {
  const program: IProgramParams = useParams();
  const { request } = usePbm2Url();
  handleFilter(options, program);

  return useQuery("transactions:" + JSON.stringify(options), async () => {
    if (options.filter?.after && filterOptions.page !== 0) filterOptions.page += 1;
    if (options.filter?.before && filterOptions.page > 1) filterOptions.page -= 1;

    transformStringToDate(options);

    const { Refund_findPbmSales }  = await request(
      gql`
      query Refund_findPbmSales($input: Refund_FindPbmSalesInputType!) {
        Refund_findPbmSales(filter:$input) {
          pageInfo{
            pageCount,
            totalCount,
            hasNextPage,
            hasPreviousPage,
            startCursor,
            endCursor
          },
          edges{
            nodes{
              pbmSales{
                pbmSaleId,
                establishmentCode,
                transactionDate,
                canceledTransactionDate,
                pbmSalesProducts{
                  pbmSaleId,
                  discount,
                  productName,
                  unitPrice,
                  productCode,
                  saleQuantity,
                  refundAmount,
                  refundStatus,
                  refundError,
                  status,
                },            
              }
            }
          }
        }
      }
      `,
      {
        input: { ...options.filter, page: filterOptions.page, first: 10 },
      }
    );
    
    const result = formatTransactions(Refund_findPbmSales);
    return result as CursorPaginated<IRefundTransaction>;
  });
}
